'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _includes2 = require('lodash/includes');
var _includes3 = _interopRequireDefault(_includes2);
var _last2 = require('lodash/last');
var _last3 = _interopRequireDefault(_last2);
var _head2 = require('lodash/head');
var _head3 = _interopRequireDefault(_head2);
exports.default = eauors;
var _utils = require('../utils/');
var utils = _interopRequireWildcard(_utils);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function lineEnter(selection, options, selector) {
  selection.append('svg:line').classed(selector, true).style(utils.lineStyle((0, _extends3.default)({}, options)));
}
var pivotLineStyle = function pivotLineStyle(style) {
  return function (pivotOptions, lineOptions) {
    return function (datum) {
      return pivotOptions.value === datum || (0, _includes3.default)(lineOptions.baselines, datum) ? pivotOptions[style] : lineOptions[style];
    };
  };
};
function xLineUpdate(selection, lineOptions, options, xScale, yRange) {
  var pivotOptions = options.axis.x.linear.pivot;
  selection.attr({
    x1: function x1(datum) {
      return xScale(datum);
    },
    y1: (0, _head3.default)(yRange),
    x2: function x2(datum) {
      return xScale(datum);
    },
    y2: (0, _last3.default)(yRange)
  }).style({
    'stroke-width': pivotLineStyle('thickness')(pivotOptions, lineOptions),
    'stroke': pivotLineStyle('color')(pivotOptions, lineOptions)
  });
}
function yLineUpdate(selection, lineOptions, options, yScale, xRange) {
  var pivotOptions = options.axis.y.linear.pivot;
  selection.attr({
    x1: (0, _head3.default)(xRange),
    y1: function y1(datum) {
      return yScale(datum);
    },
    x2: (0, _last3.default)(xRange),
    y2: function y2(datum) {
      return yScale(datum);
    }
  }).style({
    'stroke-width': pivotLineStyle('thickness')(pivotOptions, lineOptions),
    'stroke': pivotLineStyle('color')(pivotOptions, lineOptions)
  });
}
function eauors(target) {
  target.eauors = (0, _extends3.default)({}, target.eauors, {
    xLineEnter: lineEnter,
    xLineUpdate: xLineUpdate,
    yLineEnter: lineEnter,
    yLineUpdate: yLineUpdate
  });
}